//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default{
  data(){
    return{
      list1: [
        {
          value: '1年',
          name: '1年',
        },
        {
          value: '2年',
          name: '2年',
        },
        {
          value: '3年',
          name: '3年',
        },
        {
          value: '4年',
          name: '4年',
        },
        {
          value: '5年',
          name: '5年',
        }
      ],
      xufeiForm:{
        name:'',
        endtime:'',
        newtime:'',
        region:['1年'],
        coupon:[],
        yhq:[],
        price:'',
        loading:false,
        money:''
      },
    }
  },
  mounted(){
    this.config()
  },
  methods: {
    async config() {
      this.couponInfo()
      this.getPrice()
    },
    async couponInfo() {
      this.$http.post('https://api.abeiyun.com/www/user.php','cmd=userinfo').then(({data})=>{
        if(data.response == 200) {
          this.xufeiForm.money = data.msg.money
          let onuse = data.msg.yhq.onuse.map((item, index) => {
            return {
              value: item.yhq_id,
              name: '(可优惠'+ item.money_all +'元，最低消费满'+ item.money_need +'元可使用)',
              yhq_use: item.yhq_use
            }
          })
          this.xufeiForm.yhq = onuse.filter(items => {
            return items.yhq_use === '续费'
          })
          this.xufeiForm.yhq.unshift({
            value: '',
            name: '不使用优惠券',
            yhq_use: ''
          })
        }
      })
    },
    getPrice() {
      this.xufeiForm.price = '价格计算中...'
      let data = 'cmd=renew'+
        '&yewu_type=domain'+
        '&yewu_id='+ this.$route.params.id +
        '&renew_time='+ this.xufeiForm.region[0].replace('年','') +
        '&yhq_id='+ this.xufeiForm.coupon +
        '&ac_type=getprice'
      this.$http.post('https://api.abeiyun.com/www/renew.php',data).then(({data})=>{
        if(data.response == 200){
          this.xufeiForm.name = data.domainname
          this.xufeiForm.newtime = data.endtime
          this.xufeiForm.endtime = data.endtime_old
          this.xufeiForm.price = data.price
        }else{
          this.$vux.alert.show({
            title: '提示信息',
            content: data.msg,
          })
        }
      })
    },
    async Renew() {
      let data = 'cmd=renew'+
        '&yewu_type=domain'+
        '&yewu_id='+ this.$route.params.id +
        '&renew_time='+ this.xufeiForm.region[0].replace('年','') +
        '&yhq_id='+ this.xufeiForm.coupon +
        '&ac_type=renew'
      let _this = this
      this.$http.post('https://api.abeiyun.com/www/renew.php',data).then(({data})=>{
        if(data.response == 200){
          this.$vux.alert.show({
            title: '提示信息',
            content: data.msg,
            onHide () {
              _this.$router.push('/user/domain')
            }
          })
        }else{
          this.$vux.alert.show({
            title: '提示信息',
            content: data.msg,
          })
        }
      })
    },
  }
}



// WEBPACK FOOTER //
// ./src/components/console/domainrenew.vue